// +----------------------------------------------------------------------
// | CRMEB [ CRMEB 赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB 并不是自由软件，未经许可不能去掉 CRMEB 相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var salesOrgErrorLogRouter = {
  path: '/salesOrgErrorLog',
  component: Layout,
  redirect: '/salesOrgErrorLog/list',
  name: 'SalesOrgErrorLog',
  meta: {
    title: '销售机构错误日志',
    icon: 'el-icon-warning-outline',
    noCache: true,
    alwaysShow: true
  },
  children: [{
    path: 'list',
    component: function component() {
      return import('@/views/salesOrgErrorLog/index');
    },
    name: 'SalesOrgErrorLogList',
    meta: {
      title: '销售机构错误日志',
      noCache: true,
      affix: false,
      icon: 'el-icon-warning-outline',
      perms: 'api:admin:kingdee:salesorg:error:list'
    }
  }],
  // 确保这是一个顶级菜单，不属于任何其他菜单
  pid: 0
};
export default salesOrgErrorLogRouter;